import { render, staticRenderFns } from "./MessageStack.vue?vue&type=template&id=8bfe25ca"
import script from "./MessageStack.vue?vue&type=script&lang=ts"
export * from "./MessageStack.vue?vue&type=script&lang=ts"
import style0 from "./MessageStack.vue?vue&type=style&index=0&id=8bfe25ca&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports